<template>
  <section
    :class="[
      'asc-page-error--template',
      errorType === 500 || termsAndConditions ? 'no-nav' : 'in-page',
    ]"
  >
    <asc-page-error-content
      v-if="errorType === 500"
      title="500"
      subtext="Internal Server Error"
    >
      <span class="asc-page-error--support-text">
        This issue has been reported to the Ascentia Team. Please try again
        later.
      </span>
    </asc-page-error-content>
    <asc-page-error-content
      v-if="errorType === 404"
      title="404"
      subtext="Sorry, the page you tried cannot be found."
    >
      <span class="asc-page-error--support-text">
        You may have typed the address incorrectly or used an outdated link.
        This issue has been reported. For additional support, contact the
        Collins Aerospace Service Desk at
        <a
          :href="`tel:${contact.phone}`"
          class="asc-page-error--help-phone-link"
          >{{ contact.formattedPhone }}</a
        >
        <span class="asc-page-error--help-phone-text">{{
          contact.formattedPhone
        }}</span>
        or email at
        <a
          class="asc-page-error--help-email"
          :href="`mailto:${contact.email}`"
          >{{ contact.email }}</a
        >.
      </span>
    </asc-page-error-content>
    <asc-terms-and-conditions-wrapper
      v-if="termsAndConditions && !errorType"
      :last-accepted="lastAccepted"
      :loading="loading"
      :user-accepted="userAccepted"
      @submitTAndC="handleSubmission"
    />
  </section>
</template>

<script>
import AscPageErrorContent from '@/components/molecules/AscPageErrorContent'
import { AscTermsAndConditionsWrapper } from '@/components/organisms'
import { ASC_HELP_CONTACT } from '@/utilities/appConsts'

export default {
  name: 'AscPageErrorTemplate',

  components: {
    AscPageErrorContent,
    AscTermsAndConditionsWrapper,
  },

  props: {
    errorType: {
      type: [Number, String],
      default: null,
    },
    lastAccepted: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    termsAndConditions: {
      type: Boolean,
      default: false,
    },
    userAccepted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contact: ASC_HELP_CONTACT,
    }
  },

  methods: {
    handleSubmission() {
      this.$emit('userSubmit')
    },
  },
}
</script>

<style lang="scss">
.asc-page-error {
  &--support-text {
    color: $primary-black;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0;
  }
  &--template {
    background-color: $primary-white;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
    padding: 16px;

    &.no-nav {
      padding: 16px;
    }
  }
}
.asc-page-error--help-phone-text {
  display: inline;
  white-space: nowrap;
}
.asc-page-error--help-phone-link {
  display: none;
}
.asc-page-error--help-email {
  @include link-styling;
}

//mobile portrait & landscape
@media only screen and (max-width: 600px) and (orientation: portrait),
  only screen and (max-width: 960px) and (max-height: 600px) and (orientation: landscape) {
  .asc-page-error--help-phone-link {
    display: inline;
    white-space: nowrap;
    @include link-styling;
  }
  .asc-page-error--help-phone-text {
    display: none;
  }
}
</style>
